import { useEffect, useState } from "react";
import { C } from "./theme";

// How long the dots run before the screen offers a way out.
export const SLOW_LOAD_MS = 10000;

// The screen shown while Nudge signs in and loads. If loading takes too long (a phone back from sleep can
// hold a dead connection), it says so and offers Reload, so the user never has to know to refresh.
// `failed`: loading stopped with an error, so the way out shows at once. `reload` is replaceable for tests.
export function LoadingScreen({ failed = false, reload = () => window.location.reload() }) {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setSlow(true), SLOW_LOAD_MS);
    return () => clearTimeout(t);
  }, []);
  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, alignItems: "center", justifyContent: "center", gap: 16, padding: "0 24px", background: C.bg, color: C.text }}>
      <div style={{ fontFamily: "Georgia,serif", fontSize: 28, fontWeight: 800, color: C.text }}>
        Nudge<span style={{ color: C.accent }}>.</span>
      </div>
      {slow || failed ? (
        <div role="alert" style={{ display: "grid", justifyItems: "center", gap: 12, maxWidth: 320, textAlign: "center" }}>
          <p style={{ margin: 0, fontSize: 16, lineHeight: 1.5, color: C.textMid }}>
            {failed ? "We couldn't load your plan." : "This is taking longer than usual."} Check your connection, then reload.
          </p>
          <button onClick={reload}
            style={{ minHeight: 44, padding: "0 20px", borderRadius: C.rsm, border: "none", background: C.accent, color: C.onAccent, fontSize: 16, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
            Reload
          </button>
        </div>
      ) : (
        <div aria-label="Loading" role="status" style={{ display: "flex", gap: 6 }}>
          {[0, 1, 2].map(i => (
            <div key={i} style={{ width: 8, height: 8, borderRadius: "50%", background: C.accent, animation: `nd 1.2s ${i * 0.2}s infinite ease-in-out` }} />
          ))}
        </div>
      )}
    </div>
  );
}
